// 只允许 输入有效的正数
export const sensitiveCharacter = function (rule, value, callback) {
  const RE = /^[\u4e00-\u9fa5,a-zA-Z0-9]+$/
  if (!RE.test(value)) {
    callback(new Error('存在非法字符'))
  } else {
    callback()
  }
    // const RE = /[<>()$'"\\/]+/g
    // const words = ['eval', 'script']
    // let passed = true
    // words.every(w => {
    //   if (value.includes(w)) {
    //     passed = false
    //     return false
    //   }
    //   return true
    // })
  
    // if (passed) passed = !RE.test(value)
    // if (passed) {
    //   callback()
    // } else {
    //   callback(new Error('存在非法字符'))
    // }
  }
  // 只允许 字母Letter、数字number、下划线Underline
export const onlyLNU = function (rule, value, callback) {
    let RE = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])[a-zA-Z0-9]{8,16}$/
    if (!RE.test(value)) {
      callback(new Error('请输入8-16位英文大小写字母、数字组合的密码'))
    } else {
      callback()
    }
  }
  // 必填项
export const required = function (type = 'string', trigger = 'blur') {
    return { type, required: true, message: '此项为必填项', trigger }
  }